import React from 'react'
import { graphql } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { repositoryConfigs } from '../utils/prismic-previews'
import Listing from '../components/generic-listing/listing'
import Pagination from '../components/layout/pagination'
import { Layout } from '../components/global/layout'
import Masthead from '../components/layout/masthead'

const CustomerStoriesIndex = ({ data, pageContext }) => {
  if (!data) 
    return null

  const document = data.prismicCustomerStoriesIndex
  const articles = document.data.documents.slice(pageContext.pageInfo.start, pageContext.pageInfo.end)

  const customer_stories = []

  articles.map((article, i) => {
    const story = article.customer_story.document

    if (story && story.data.short_title && story.data.short_title.text) {
      return (
        customer_stories.push({ ...story, data: { ...story.data, title: story.data.short_title } })
      )
    }

    return (
      customer_stories.push(story)
    )
  })
  
  return (
    <Layout pageTitle={document.data.title.text} 
            metaTitle={document.data.meta_title.text} 
            metaDescription={document.data.meta_description.text || document.data.summary.text}
            shareImage={document.data.share_image.url}>
      <Masthead subtitle={document.data.subtitle.text}
                title={document.data.title.text}
                summary={document.data.summary.text} />
      <Listing articles={customer_stories} />
      <Pagination pageInfo={pageContext.pageInfo} basePath={document.url} />
    </Layout>
  )
}

export const query = graphql`
  query CustomerStoriesIndexPageQuery {
    prismicCustomerStoriesIndex {
      _previewable
      data {
        title {
          text
        }
        summary {
          text
        }
        subtitle {
          text
        }
        share_image {
          url
        }
        meta_title {
          text
        }
        meta_description {
          text
        }
        documents {
          customer_story {
            document {
              ... on PrismicCustomerStory {
                id
                data {
                  listing_image {
                    url
                    alt
                  }
                  summary {
                    text
                  }
                  title {
                    text
                  }
                  short_title {
                    text
                  }
                }
                url
              }
            }
          }
        }
      }
      url
      tags
    }
  }
`

export default withPrismicPreview(CustomerStoriesIndex, repositoryConfigs)